import LocationGraphics from './LocationGraphics';

let path = '././assets/images/';
let pathSounds = '././assets/sounds/';
let assetArray = [{
    id: 'kaumatua',
    path: path + 'kaumatua.svg'
}, {
    id: 'photo',
    path: path + 'photo.svg'
}, {
    id: 'shell',
    path: path + 'shell.svg'
}, {
    id: 'dictionary',
    path: path + 'dictionary.svg'
}, {
    id: 'kete',
    path: path + 'kete.svg'
}, {
    id: 'aoraki',
    path: path + 'aoraki.svg'
}, {
    id: 'dictionaryBG',
    path: path + 'dictionary-bg.svg'
}, {
    id: 'dictAoraki',
    path: path + 'dict-aoraki.svg'
}, {
    id: 'dictHarakeke',
    path: path + 'dict-harakeke.svg'
}, {
    id: 'dictMatau',
    path: path + 'dict-matau.svg'
}, {
    id: 'dictPoutokomanawa',
    path: path + 'dict-poutokomanawa.svg'
}, {
    id: 'dictPou',
    path: path + 'dict-pou.svg'
}, {
    id: 'dictPutatara',
    path: path + 'dict-putatara.svg'
}, {
    id: 'dictTiKouka',
    path: path + 'dict-ti-kouka.svg'
}, {
    id: 'dictWharenui',
    path: path + 'dict-wharenui.svg'
}, {
    id: 'dictWhariki',
    path: path + 'dict-whariki.svg'
}, {
    id: 'dictWhenua',
    path: path + 'dict-whenua.svg'
}, {
    id: 'dictIcon',
    path: path + 'dict-icon.svg'
}, {
    id: 'dictAoraki',
    path: pathSounds + 'book/aoraki.mp3'
}, {
    id: 'dictHarakeke',
    path: pathSounds + 'book/harakeke.mp3'
}, {
    id: 'dictMatau',
    path: pathSounds + 'book/matau.mp3'
}, {
    id: 'dictPou',
    path: pathSounds + 'book/poupou.mp3'
}, {
    id: 'dictPoutokomanawa',
    path: pathSounds + 'book/poutokomanawa.mp3'
}, {
    id: 'dictPutatara',
    path: pathSounds + 'book/putatara.mp3'
}, {
    id: 'dictTiKouka',
    path: pathSounds + 'book/ti_kouka.mp3'
}, {
    id: 'dictWharenui',
    path: pathSounds + 'book/wharenui.mp3'
}, {
    id: 'dictWhariki',
    path: pathSounds + 'book/whariki.mp3'
}, {
    id: 'dictWhenua',
    path: pathSounds + 'book/whenua.mp3'
}, {
    id: 'kaumatua',
    path: pathSounds + 'kaumatua.mp3'
}];

export default class KaumatuaGraphics extends LocationGraphics {
    constructor() {
        super('kaumatuaGraphics');
        this.assetArray = assetArray;
    }

    addGraphics(container) {
        this.parent.cameras.main.setBackgroundColor('rgba(0, 0, 0, 1)');
        let pe = 'photograph';
        let pm = 'whakaahua';
        let ae = 'photograph of ancestor';
        let am = 'whakaahua tipuna';
        this.graphicArray = [{
                id: 'kaumatua',
            }, {
                id: 'photo',
                x: 377,
                y: 39,
                maori: am,
                english: ae,
                location: 'photo',
                scale: 0.2
            }, {
                id: 'shell',
                x: 615,
                y: 359,
                maori: 'pūtātara',
                english: 'conch instrument',
                location: 'shell',
                scale: 0.17
            }, {
                id: 'kete',
                x: 479,
                y: 126,
                maori: 'kete',
                english: 'woven baskets',
                location: 'kete',
                scale: 0.51
            }, {
                id: 'aoraki',
                x: 357,
                y: 126,
                maori: 'Aoraki',
                english: 'Mt Cook',
                location: 'aoraki',
                scale: 0.3
            }, {
                id: 'dictionary',
                x: 64,
                y: 389,
                maori: 'papakupu',
                english: 'dictionary',
                location: 'dictionary'

            },
            /***** TOOLTIPS */
            {
                x: -5,
                y: 348,
                maori: 'papa',
                english: 'floor',
                hit: [
                    [0, 249],
                    [0, 112],
                    [115, 41],
                    [227, 150],
                    [293, 106],
                    [264, 10],
                    [663, 0],
                    [692, 112],
                    [703, 249],

                ]
            }, {
                x: 567,
                y: 260,
                maori: 'kāpata iti',
                english: 'cabinet',
                hit: [
                    [0, 125],
                    [44, 0],
                    [144, 23],
                    [164, 154],
                    [86, 212],

                ]
            }, {
                x: -1,
                y: -3,
                maori: 'tuanui',
                english: 'ceiling',
                hit: [
                    [0, 0],
                    [797, 0],
                    [797, 145],
                    [658, 172],
                    [401, 4],
                    [154, 160],
                    [0, 146],

                ]
            },
            {
                x: 225,
                y: 217,
                maori: 'paenga pukapuka',
                english: 'bookshelf',
                hit: [
                    [0, 0],
                    [68, 0],
                    [68, 118],
                    [0, 118],
                ]
            },
            {
                x: 38,
                y: 158,
                maori: 'rama',
                english: 'lamp',
                hit: [
                    [0, 62],
                    [46, 0],
                    [81, 0],
                    [103, 83],
                    [45, 91],
                ]

            }, {
                x: 290,
                y: 238,
                maori: 'hopa',
                english: 'couch',
                hit: [
                    [7, 169],
                    [0, 101],
                    [20, 74],
                    [25, 5],
                    [232, 0],
                    [242, 67],
                    [272, 102],
                    [253, 166],
                ]

            }, {
                x: 303,
                y: 234,
                maori: 'paraikete',
                english: 'blanket',
                hit: [
                    [0, 26],
                    [20, 0],
                    [227, 0],
                    [202, 37],
                    [129, 66],
                    [28, 15],
                ]

            }, {
                x: 57,
                y: 417,
                maori: 'tēpu',
                english: 'table',
                hit: [
                    [10, 91],
                    [0, 5],
                    [83, 0],
                    [80, 86],
                ]
            }, {
                x: 473,
                y: 292,
                maori: 'aupuru',
                english: 'cushion',
                hit: [
                    [0, 35],
                    [33, 0],
                    [61, 34],
                    [36, 67],
                ]
            }, {
                x: 105,
                y: 288,
                maori: 'tūru / nohoanga',
                english: 'armchair',
                hit: [
                    [70, 177],
                    [25, 149],
                    [3, 101],
                    [0, 26],
                    [20, 0],
                    [24, 6],
                    [14, 32],
                    [25, 69],
                    [63, 80],
                    [85, 106],
                    [83, 135],
                    [95, 132],
                    [107, 153],
                ]
            }, {
                x: 6,
                y: 263,
                maori: pm,
                english: pe,
                hit: [
                    [0, 96],
                    [0, 8],
                    [64, 0],
                    [67, 76],

                ]
            }, {
                x: 244,
                y: 232,
                maori: pm,
                english: pe,
                hit: [
                    [0, 26],
                    [0, 0],
                    [19, 0],
                    [21, 25],
                ]
            }, {
                x: 223,
                y: 128,
                maori: pm,
                english: pe,
                hit: [
                    [0, 32],
                    [0, 9],
                    [34, 0],
                    [70, 5],
                    [77, 23],
                    [83, 39],
                    [107, 39],
                    [109, 74],
                    [83, 74],
                    [83, 39],
                    [77, 23],

                ]
            }, {
                x: 668,
                y: 201,
                maori: pm,
                english: pe,
                hit: [
                    [0, 48],
                    [0, 0],
                    [47, 0],
                    [47, 48],

                ]
            }, {
                x: 720,
                y: 170,
                maori: 'ārai',
                english: 'curtains',
                hit: [
                    [0, 171],
                    [11, 2],
                    [85, 0],
                    [80, 180],
                ]
            }, {
                x: 330,
                y: 291,
                maori: 'kete',
                english: 'woven baskets',
                hit: [
                    [15, 58],
                    [0, 31],
                    [20, 0],
                    [51, 10],
                    [60, 42],
                ]
            }, {
                x: 165,
                y: 438,
                maori: 'whāriki',
                english: 'floor mat',
                hit: [
                    [0, 127],
                    [138, 5],
                    [399, 0],
                    [537, 116],
                    [257, 162],

                ]
            }, {
                x: 610,
                y: 295,
                maori: 'whakakapi',
                english: 'earrings',
                hit: [
                    [0, 22],
                    [7, 0],
                    [17, 0],
                    [17, 22],

                ]
            }, {
                x: 635,
                y: 312,
                maori: 'heru',
                english: 'comb',
                hit: [
                    [14, 35],
                    [9, 31],
                    [0, 0],
                    [11, 3],
                    [18, 29],

                ]
            }, {
                x: 651,
                y: 317,
                maori: 'poi',
                english: 'performance item',
                hit: [
                    [6, 31],
                    [0, 0],
                    [17, 1],
                    [21, 9],
                    [16, 34],
                ]
            }, {
                x: 651,
                y: 317,
                maori: 'poi',
                english: 'performance item',
                hit: [
                    [6, 31],
                    [0, 0],
                    [17, 1],
                    [21, 9],
                    [16, 34],
                ]
            }, {
                x: 588,
                y: 336,
                maori: 'pāua',
                english: 'abalone shell',
                hit: [
                    [6, 33],
                    [0, 25],
                    [2, 9],
                    [32, 0],
                    [40, 12],
                    [27, 29],
                ]
            }, {
                x: 261,
                y: 183,
                maori: 'pāua',
                english: 'abalone shell',
                hit: [
                    [10, 23],
                    [0, 14],
                    [7, 2],
                    [31, 0],
                    [39, 12],
                    [30, 22],

                ]
            }, {
                x: 676,
                y: 371,
                maori: 'rakau',
                english: 'sticks',
                hit: [
                    [0, 40],
                    [8, 0],
                    [23, 3],
                    [26, 26],
                ]
            }, {
                x: 242,
                y: 283,
                maori: 'reo irirangi (Tahu FM)',
                english: 'radio (Tahu FM)',
                hit: [
                    [0, 0],
                    [34, 0],
                    [34, 34],
                    [0, 34],
                ]
            }, {
                x: 162,
                y: 164,
                maori: 'pukapuka',
                english: 'books',
                hit: [
                    [0, 0],
                    [69, 10],
                    [69, 41],
                    [0, 41],
                ]
            }, {
                x: 231,
                y: 176,
                maori: 'pounamu',
                english: 'greenstone/jade',
                hit: [
                    [0, 29],
                    [11, 0],
                    [15, 0],
                    [31, 29],

                ]
            }, {
                x: 209,
                y: 433,
                maori: 'hiripa',
                english: 'slippers',
                hit: [
                    [0, 13],
                    [42, 0],
                    [68, 25],
                    [36, 54],
                    [0, 32],
                ]
            }, {
                x: 321,
                y: 70,
                maori: am,
                english: ae,
                hit: [
                    [0, 0],
                    [24, 0],
                    [30, 54],
                    [3, 57],

                ]
            }, {
                x: 450,
                y: 62,
                maori: am,
                english: ae,
                hit: [
                    [0, 0],
                    [28, 0],
                    [34, 54],
                    [2, 57],

                ]
            }, {
                x: 0,
                y: 487,
                maori: 'tūru hakahaka',
                english: 'low seat',
                hit: [
                    [0, 0],
                    [79, 4],
                    [103, 42],
                    [91, 88],
                    [47, 101],
                    [0, 85],
                ]
            }, {
                x: 125,
                y: 251,
                maori: 'kāmeta',
                english: 'scarf',
                hit: [
                    [0, 47],
                    [0, 33],
                    [16, 4],
                    [35, 0],
                    [19, 17],
                    [30, 48],

                ]
            }
        ];


        for (let index = 0; index < this.graphicArray.length; index++) {
            container.add(this.utils.addImage(this.parent, this.graphicArray[index]));
        }

        super.addGraphics();
    }
}